/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import PatientMarker from './patient-marker';
import PatientMarkerDetail from './patient-marker-detail';
import PatientMarkerUpdate from './patient-marker-update';
import PatientMarkerDeleteDialog from './patient-marker-delete-dialog';

const PatientMarkerRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<PatientMarker />} />
    <Route path="new" element={<PatientMarkerUpdate />} />
    <Route path=":id">
      <Route index element={<PatientMarkerDetail />} />
      <Route path="edit" element={<PatientMarkerUpdate />} />
      <Route path="delete" element={<PatientMarkerDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default PatientMarkerRoutes;
